import {Col, Row} from 'react-bootstrap';
import React from 'react';
import Card from '../../elements/ReactBootstrap/Card.jsx';
import PropTypes from 'prop-types';
import ApplicationsListWidget from '../ApplicationsListWidget.jsx';

const ApplicationSearchResult = ({
    results,
}) => {
    const length = results.length;

    if (length < 1) {
        return null;
    }

    return (<Row>
        <Col>
            <Card noPadding header={'Предложения (' + length + ')'}>
                <ApplicationsListWidget applications={results} />
            </Card>
        </Col>
    </Row>);
};

ApplicationSearchResult.propTypes = {
    results: PropTypes.array,
};

export default ApplicationSearchResult;
